import { Component, OnInit, AfterViewInit } from '@angular/core';
import { AuthService, ScrollService, MessagesServices } from '../../api/';
import { ToastyService, ToastyConfig, ToastOptions } from 'ng2-toasty';
import { ActivatedRoute } from '@angular/router';
import { Router } from '@angular/router';
import { ConfirmDialogComponent } from '../../';
import { MdDialog, MdDialogRef } from '@angular/material';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.css']
})
export class ResetPasswordComponent implements OnInit, AfterViewInit {
  public password: string = '';
  private token: string = '';
  private loading: boolean = false;
  private errorArray: any = [];
  private validToken: boolean = true;
  private messages: any = new Array<any>();
  msg1: any = '';
  title1: any = '';
  constructor(private authService: AuthService, private sm: MessagesServices, private toastyService: ToastyService, private toastyConfig: ToastyConfig,
    private route: ActivatedRoute, private scrollService: ScrollService, private router: Router, public dialog: MdDialog) {
    this.toastyConfig.theme = 'material';
    //getting messages from db
    this.messages = this.sm.messags;
    this.setMessages();
  }
  /**
     * setting system messages
     **/

  setMessages() {
    this.msg1 = '';
    this.title1 = '';
    if (this.messages) {
      for (var i = 0; i < this.messages.length; i++) {
        if (this.messages[i].event == 'WG_EVENT_YOUR_PASSWORD_CHANGED_SUCCESSFULLY') {
          this.title1 = this.messages[i].title;
          this.msg1 = this.messages[i].message;
        }
      }
    }
  }
  ngOnInit() {
    if (this.authService.isUserLoggedIn() === true) {
      this.router.navigate(['/']);
    }
    this.route.params.subscribe((params) => {
      this.token = params['token'];
      this.scrollService.toggleProgressBar(true);
      this.authService.validatePasswordResetToken(this.token).subscribe((res) => {
        if (res.text() === 'Link has been Expired. Token is already been utlized or expired.') {
          this.validToken = false;
        }
      }, (err) => {
        this.validToken = false;
      }, () => {
        this.scrollService.toggleProgressBar(false);
      });
    });
  }

  ngAfterViewInit() {
    this.scrollService.toggleProgressBar(false);
  }

  sendPasswordResetRequest() {
    // this.setMessages();
    this.scrollService.toggleProgressBar(true);
    this.loading = true;
    this.authService.resetPassword(this.token, this.password).subscribe((res) => {
      let toastOptions: ToastOptions = {
        title: this.title1,
        msg: this.msg1,
        showClose: true,
        timeout: 2000,
        theme: 'default'
      };
      this.scrollService.toggleProgressBar(false);
      this.loading = false;
      this.toastyService.success(toastOptions);
      this.router.navigate(['/login']);
    }, (err) => {
      this.scrollService.toggleProgressBar(false);
      this.loading = false;
      this.handleErrors(err);
    });
  }

  handleErrors(err: any) {
    this.errorArray = [];
    let validationErrors = JSON.parse(err._body);
    if (validationErrors.message) {
      let dialogRef = this.dialog.open(ConfirmDialogComponent);
      dialogRef.componentInstance.heading = 'Opps, Something went wrong.';
      dialogRef.componentInstance.infoMode = true;
      dialogRef.componentInstance.message = validationErrors.message;
    } else if (err._body) {
      for (let index = 0; index < validationErrors.length; index++) {
        this.errorArray[validationErrors[index].field] = validationErrors[index].message;
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/user/reset-password/reset-password.component.ts